import styles from './BlendingBackground.module.css';

export const BlendingBackground = ({ children }: { children: React.ReactNode }) => {
	return <div className={styles.root}>{children}</div>;
};
